(function() {
  $(document).ready(function() {
    $(document).on("swell:setup", function() {
      SwellConfig.Referral.initializeReferral(".swell-referral");
      setupReferrals();
      $("#swell-loading-spinner").hide();
      function setupReferrals (){
        if(spapi.authenticated) {
          if(spapi.customer.referral_receipts.length > 0) {
            $(".referral-table").show();

            referrals = spapi.customer.referral_receipts;

            referrals.forEach(function(referral) {
              status = null;

              if(referral.completed_at){
                status = "Purchased";
              } else {
                status = "Invited";
              }

              $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
            });
          }
        }
      }

      $("#swell-reward-post-checkout").show();
      $( 'body' ).on('click',".swell-reward-post-checkout-holder .checkout-heading .swell-referral-back-link", function() {
        $("#swell-reward-post-checkout").hide();
     });

      $( 'body' ).on('click',"#swell-referral-refer-submit", function() {
        setTimeout(function(){
          if($(".swell-referral-thanks").length > 0){
            swellAPI.refreshCustomerDetails(function(){
              var customerDetails = swellAPI.getCustomerDetails();
              referrals = customerDetails.referrals;

              $(".swell-referral-table tbody").html("");

              referrals.forEach(function(referral) {
                status = null;

                if(referral.completed_at){
                  status = "Purchased";
                } else {
                  status = "Invited";
                }

                $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
              });
            });
          }
        }, 1500);
      });
    });
  });
}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: '<span class="heading-content">Be a Hero</span>Give $15, Get <%= referralCampaign.reward_text %>',
        referralRegisterFormDetails: "Enter your email to start referring friends. Log in to check your rewards balance.",
        referralRegisterFormEmail: "example@gmail.com",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: '<span class="heading-content">Be a Hero</span>Give $15, Get <%= referralCampaign.reward_text %>',
        referralReferFormEmails: "Enter your friends' emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "Share your link with the buttons below. Log in to see your balance.",

        referralShareFacebook: "",
        referralShareTwitter: "",
        referralShareCopy: "",
        referralShareSms: "",

        referralFacebookIcon: "fa fa-facebook",
        referralTwitterIcon: "fa fa-twitter",
        referralLinkIcon: "icon-link-icon",
        referralSmsIcon: "fa fa-mobile",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "COPY LINK",
        referralCopyDetails: "Copy link and share with your friends"
      },
      templates: {
       referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%=localization.referralReferHeading %></h2> <p class="swell-referral-details"><%=localization.referralReferDetails %></p><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%=localization.referralReferFormDetails %></p></div><div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <label for="swell-referral-refer-emails" class="sr-only">Enter your email addresses separated by commas</label><input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%=localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%=localization.referralReferFormEmailsDetails %></span> </li></ul> </div><div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%=localization.referralReferFormSubmit %>"> </div></form> </div><div class="swell-referral-media-wrapper"> <span class="swell-referral-media-seperator">OR</span> <p class="swell-referral-media-details"><%=localization.referralReferMediaDetails %></p><ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%=localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%=localization.referralShareCopy %> </div></li><li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%=localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%=localization.referralShareFacebook %> </div></li><li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%=localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp;<%=localization.referralShareTwitter %> </div></li><li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%=localization.referralSmsIcon %>" aria-hidden="true"></i>&nbsp;<%=localization.referralShareSms %> </div></li></ul> </div></div>'
     },
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);

